export const YUSA_OVERNIGHT_CAMP_GET_REVENUE_SUCCESS =
  'YUSA_OVERNIGHT_CAMP_REVENUE_SUCCESS';
export const YUSA_OVERNIGHT_CAMP_GET_REVENUE_FAILURE =
  'YUSA_OVERNIGHT_CAMP_REVENUE_FAILURE';
export const YUSA_OVERNIGHT_CAMP_REVENUE_LIST_SUCCESS =
  'YUSA_OVERNIGHT_CAMP_REVENUE_SUCCESS';
export const YUSA_OVERNIGHT_CAMP_REVENUE_LIST_FAILURE =
  'YUSA_OVERNIGHT_CAMP_REVENUE_LIST_FAILURE';
export const YUSA_OVERNIGHT_CAMP_GET_EXPENSES_SUCCESS =
  'YUSA_OVERNIGHT_CAMP_EXPENSES_SUCCESS';
export const YUSA_OVERNIGHT_CAMP_GET_EXPENSES_FAILURE =
  'YUSA_OVERNIGHT_CAMP_EXPENSES_FAILURE';
export const YUSA_OVERNIGHT_CAMP_EXPENSES_LIST_SUCCESS =
  'YUSA_OVERNIGHT_CAMP_EXPENSES_LIST_SUCCESS';
export const YUSA_OVERNIGHT_CAMP_EXPENSES_LIST_FAILURE =
  'YUSA_OVERNIGHT_CAMP_EXPENSES_LIST_FAILURE';
